import * as Sentry from '@sentry/react';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { NavbarIconButtonWithLabel } from '../NavbarIconButtonWithLabel';
import { FeedbackIcon } from '../icons/FeedbackIcon';

const FeedbackLauncher = () => {
  const { t } = useTranslation();
  const feedback = Sentry.getFeedback();

  const handleClick = async () => {
    const form = await feedback?.createForm();
    if (form) {
      form.appendToDom();
      form.open();
    }
  };

  return (
    <NavbarIconButtonWithLabel
      active={false}
      label={t('Feedback')}
      onClick={handleClick}
    >
      <FeedbackIcon />
    </NavbarIconButtonWithLabel>
  );
};

export default FeedbackLauncher;
